export default __webpack_public_path__ + "static/media/babolat.a8a0479a.svg";